import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "role-container"
};
const _hoisted_2 = {
  class: "attribute-item-group"
};
const _hoisted_3 = {
  class: "operation-bar"
};
const _hoisted_4 = {
  class: "avatar-property-row"
};
const _hoisted_5 = {
  class: "avatar-container"
};
const _hoisted_6 = {
  class: "attribute-item-title"
};
const _hoisted_7 = {
  class: "attribute-item-value"
};
const _hoisted_8 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_9 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_10 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_11 = {
  class: "info-container"
};
const _hoisted_12 = {
  class: "attribute-item-value"
};
const _hoisted_13 = {
  class: "special"
};
const _hoisted_14 = {
  class: "attribute-item-value"
};
const _hoisted_15 = {
  key: 0,
  class: "attribute-item-value"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  class: "attribute-item-value"
};
const _hoisted_18 = {
  class: "attribute-item-value reputation"
};
const _hoisted_19 = {
  class: "attribute-item-value"
};
const _hoisted_20 = {
  class: "attribute-item-value"
};
const _hoisted_21 = {
  class: "attribute-item-value"
};
const _hoisted_22 = {
  class: "attribute-item-value"
};
const _hoisted_23 = {
  class: "attribute-item-value"
};
const _hoisted_24 = {
  class: "biography"
};
import { computed, onMounted } from 'vue';
import store from '@/store';
import { request } from '@/manager/net_manager';
import { getDamageAndBuild, getGender, getMovement, getProperty, featOptions } from '@/tools/utils';
import { ElCol, ElImage, ElProgress, ElRow } from 'element-plus'; // pre-declaration

export default {
  __name: 'ApplicationRoleCard',
  props: {
    roleId: {
      type: String,
      required: true
    }
  },
  emits: ['closeRole'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // computed

    const stage = computed(() => store.state.stage ?? null);
    const role = computed(() => {
      if (!stage.value) return null;
      if (!stage.value.roleInfo) return null;
      return stage.value.roleInfo[props.roleId];
    });
    const damageAndBuild = computed(() => {
      if (!role.value) return [['', ''], ['', '']];
      return [getDamageAndBuild(role.value), getDamageAndBuild(role.value, true)];
    });
    const sanityDesc = computed(() => {
      if (!role.value) return '';
      let sanityPoint = parseInt(role.value['sanity_point'] ?? '0');
      let mythology = parseInt(role.value['mythology'] ?? '0');
      let adjustSanityPoint = sanityPoint - role.value.properties.pow;

      if (sanityPoint + mythology <= 100) {
        return `${role.value['sanity_point']} / ${role.value['sanity_point']}`;
      }

      let currentSanityPoint = 100 - mythology + adjustSanityPoint;
      return `${currentSanityPoint.toString()} / (${role.value['sanity_point']} -> ${currentSanityPoint.toString()})`;
    }); // functions

    const getData = (force = false) => {
      if (force || stage.value && props.roleId && !role.value) {
        let parameters = {
          'stage_id': stage.value.stage_id,
          'role_id': props.roleId
        };
        request('stage/role/get/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            let stageData = structuredClone(stage.value);

            if (!stageData.roleInfo) {
              stageData.roleInfo = {};
            }

            stageData.roleInfo[props.roleId] = response.data;
            store.commit('update_stage', stageData);
          }
        });
      }
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return role.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElCol), null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => getData(true))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("b", null, "刷新信息", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => emits('closeRole', props.roleId))
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("b", null, "取消展示", -1)]))]),
          _: 1
        })]), _cache[17] || (_cache[17] = _createElementVNode("div", {
          class: "group-gap"
        }, null, -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(ElImage), {
          src: role.value.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"])]), _createVNode(_unref(ElCol), {
          offset: 1,
          span: 15
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "attribute-item-grid"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(role.value.properties, (value, key, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: "attribute-item-grid-card"
              }, [_createElementVNode("text", _hoisted_6, _toDisplayString(`${_unref(getProperty)(key)}(${key})`), 1), _createElementVNode("text", _hoisted_7, _toDisplayString(value), 1)]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        })]), _cache[18] || (_cache[18] = _createElementVNode("div", {
          class: "group-gap"
        }, null, -1)), _cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "group-gap"
        }, null, -1)), _createVNode(_unref(ElRow), {
          class: "attribute-item-row-pure"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("text", {
                class: "attribute-item-title"
              }, "生命值", -1)), _createVNode(_unref(ElProgress), {
                percentage: 100,
                "text-inside": true,
                "stroke-width": 16,
                class: "attribute-item-progress hp_progress"
              }, {
                default: _withCtx(() => [_createElementVNode("text", _hoisted_8, _toDisplayString(`${role.value.health_point} / ${role.value.health_point}`), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("text", {
                class: "attribute-item-title"
              }, "法力值", -1)), _createVNode(_unref(ElProgress), {
                percentage: 100,
                "text-inside": true,
                "stroke-width": 16,
                class: "attribute-item-progress mp_progress"
              }, {
                default: _withCtx(() => [_createElementVNode("text", _hoisted_9, _toDisplayString(`${role.value.magic_point} / ${role.value.magic_point}`), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("text", {
                class: "attribute-item-title"
              }, "理智值", -1)), _createVNode(_unref(ElProgress), {
                percentage: 100,
                "text-inside": true,
                "stroke-width": 16,
                class: "attribute-item-progress san_progress"
              }, {
                default: _withCtx(() => [_createElementVNode("text", _hoisted_10, _toDisplayString(sanityDesc.value), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "group-gap"
        }, null, -1)), _cache[21] || (_cache[21] = _createElementVNode("div", {
          class: "group-gap"
        }, null, -1)), _createElementVNode("div", _hoisted_11, [_createVNode(_unref(ElCol), {
          span: 14,
          class: "padding-container"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[7] || (_cache[7] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "链接角色", -1)), _createElementVNode("text", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(`${role.value.realm.desc} ${role.value.level}`), 1), _createTextVNode("  /  " + _toDisplayString(role.value.id) + " /  ", 1), _createElementVNode("b", null, _toDisplayString(role.value.nickname), 1)])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "角色信息", -1)), _createElementVNode("text", _hoisted_14, _toDisplayString(role.value.age) + "岁 /  " + _toDisplayString(role.value.race) + " /  " + _toDisplayString(_unref(getGender)(role.value.gender)) + " /  " + _toDisplayString(role.value.work), 1)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "核心组织信息", -1)), role.value.organization ? (_openBlock(), _createElementBlock("text", _hoisted_15, [_createTextVNode(_toDisplayString(role.value.organization.name) + "  " + _toDisplayString(role.value.organization.position_held) + " ", 1), role.value.feats_level >= 1 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "  / 功勋" + _toDisplayString(_unref(featOptions)[role.value.feats_level - 1]) + "级（" + _toDisplayString(role.value.feats_level) + "） ", 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "链接信息", -1)), _createElementVNode("text", _hoisted_17, " 链接于 " + _toDisplayString(role.value.era) + " /  " + _toDisplayString(role.value.nationality), 1)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "角色称号", -1)), _createElementVNode("text", _hoisted_18, _toDisplayString(role.value.reputation && role.value.reputation.length > 0 ? role.value.reputation : '未获取'), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          offset: 1,
          span: 9,
          class: "padding-container"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "物理强度", -1)), _createElementVNode("text", _hoisted_19, [_createTextVNode(_toDisplayString(damageAndBuild.value[0][1]) + " ", 1), _createElementVNode("span", null, " （" + _toDisplayString(damageAndBuild.value[0][0]) + "） ", 1)])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "灵体强度", -1)), _createElementVNode("text", _hoisted_20, _toDisplayString(`${damageAndBuild.value[1][1]}（${damageAndBuild.value[1][0]}）`), 1)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "移动力", -1)), _createElementVNode("text", _hoisted_21, _toDisplayString(_unref(getMovement)(role.value)), 1)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "神话知识", -1)), _createElementVNode("text", _hoisted_22, _toDisplayString(role.value.mythology), 1)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "attribute-item-row"
          }, {
            default: _withCtx(() => [_cache[16] || (_cache[16] = _createElementVNode("text", {
              class: "attribute-item-title"
            }, "神秘等级", -1)), _createElementVNode("text", _hoisted_23, _toDisplayString(role.value.mysterious_level), 1)]),
            _: 1
          })]),
          _: 1
        })]), _cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "group-gap"
        }, null, -1)), _cache[23] || (_cache[23] = _createElementVNode("div", {
          class: "group-gap"
        }, null, -1)), _createVNode(_unref(ElRow), {
          class: "padding-container biography-container"
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_24, _toDisplayString(role.value.biography && role.value.biography.length > 0 ? role.value.biography : '没有检测到角色生平'), 1)]),
          _: 1
        })])]),
        _: 1
      })])) : _createCommentVNode("", true);
    };
  }

};